/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Validation_Amountexceedstarget4Inputs */

const en_coinvestments_indicateinterest_validation_amountexceedstarget4 = /** @type {(inputs: Coinvestments_Indicateinterest_Validation_Amountexceedstarget4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount cannot exceed the target amount`)
};

/**
* | output |
* | --- |
* | "Amount cannot exceed the target amount" |
*
* @param {Coinvestments_Indicateinterest_Validation_Amountexceedstarget4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_validation_amountexceedstarget4 = /** @type {((inputs?: Coinvestments_Indicateinterest_Validation_Amountexceedstarget4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Validation_Amountexceedstarget4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_validation_amountexceedstarget4(inputs)
});
export { coinvestments_indicateinterest_validation_amountexceedstarget4 as "coInvestments_indicateInterest_validation_amountExceedsTarget" }